/**
 * Testa se determinado elemento representa uma cor hexadecimal.
 * @param cor Cor para ser testada.
 * @param fallback Cor caso o hex não seja válido.
 * @returns Cor em formato hexadecimal
 */
export function TestaHexDeCor(cor: string, fallback: string = '#e5e5e5') {
  const hexColorRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
  if (hexColorRegex.test(String(cor))) return cor;
  else return fallback;
}
